var initializeAnimatedBox = function () {
    var animatedBoxAnimationClass = 'c-animated-box__item-animation';
    var hoverClass = 'hover';
    document.querySelectorAll('.' + animatedBoxAnimationClass).forEach(function (animationItem) {
        animationItem.addEventListener('touchstart', function (event) {
            document.querySelectorAll('.' + animatedBoxAnimationClass + '.' + hoverClass)
                .forEach(function (hoverItem) {
                if (hoverItem !== animationItem) {
                    hoverItem.classList.toggle(hoverClass);
                }
            });
            var target = event.target;
            target.classList.toggle(hoverClass);
        });
    });
};
export default initializeAnimatedBox;
